<template>
	<div v-if="loading">
		Loading ...
	</div>
	<div v-else>
		<div class="text-right flex align-items" style="background: #efefef;padding:15px;border:1px solid #ccc">
			<h2 style="margin:0">Events</h2>
			<div class="flex-grow text-right">
				<input v-if="!resource" type="text" v-model="search" placeholder="Search and ENTER" v-on:keyup.enter="updateSearch()" />
				<button v-on:click="load()" class="small-margin-left">Refresh</button>
				<button v-on:click="clearAll()" class="small-margin-left">Clear all</button>
			</div>
		</div>
		<div style="border:1px solid #ccc;border-top:none">
			<div class="event-item" v-for="event in eventsSorted" v-bind:class="{
				info: event.level == 'info',
				error: event.level == 'error',
				debug: event.level == 'debug',
				warning: event.level == 'warning'
			}">
				<div class="flex align-items" style="padding: 10px;border-bottom:1px solid #ddd;">
					<div class="icon" style="margin-right: 10px;">
						<SvgFile size="20" v-if="event.level == 'info'" name="info" />
						<SvgFile size="20" v-if="event.level == 'error'" name="error" />
						<SvgFile size="20" color="orange" v-if="event.level == 'warning'" name="warning" />
					</div>
					<div>
						<div>
							<strong v-if="!resource">{{ event.resource }}</strong>
							{{ event.message }}
							<template v-if="event.user_id">
								<div v-for="user in getUsers" v-if="user.id == event.user_id">
									<strong>By: </strong>
									{{ user.shortened_name }}
								</div>
							</template>
						</div>
						<div class="note" style="margin-top: 6px;">
							{{ event.created_at }}
							- <a class="link" v-on:click="deleteEvent(event.id)">delete</a>
						</div>
					</div>
				</div>
			</div>
			<div style="padding: 15px;" v-if="!Object.keys(events).length">
				No events for this {{ resource ? resource.replace(/^([a-z]+).*?$/, '$1') : object }}
			</div>
		</div>
	</div>
</template>

<style lang="less" scoped>
	.event-item {
		font-size: 13px;
		&.warning {
			color: orange;
		}
	}
</style>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  props: [
    'resource',
    'autoload'
  ],
  data: () => ({
    loading: false,
    events: {},
    search: ''
  }),
  computed: {
    ...mapGetters([
      'getUsers'
    ]),
    eventsSorted () {
      return _.orderBy(this.events, ['updated_at'], ['desc'])
    }
  },
  methods: {
    updateSearch () {
      this.load()
    },
    deleteEvent (id) {
      Vue.api.delete('/event/' + id, {}, {
        callback: () => this.load()
      })
    },
    clearAll () {
      Vue.api.delete('/events', {
        resource: this.resource
      }, {
        callback: () => this.load()
      })
    },
    load () {
      Vue.api.post('/events', {
        resource: this.resource,
        search: this.search
      }, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.events = data.reverse() // this.resource ? data.reverse() : data
      })
    }
  },
  created () {
    if (this.autoload) {
      this.load()
    }
  }
}
</script>
